import styled from '@emotion/styled'
import type { Theme } from '@mui/material'

const Container = styled.div`
	display: flex;
`

const LogoWrapper = styled.div`
	position: absolute;
	display: flex;
	align-items: center;
	right: 0.5rem;
	top: 1rem;
`

const Root = styled.div`
	display: flex;
`

const Content = styled.main`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	padding: ${({ theme }: { theme: Theme }) => theme.spacing(3)};
	overflow: hidden;
	padding-left: 100px;
`

const Logo = styled.img`
	max-height: 80px;
`

export { Container, Content, Logo, LogoWrapper, Root }
